import apiConfig from "../../config/apiConfig";
import { IS_PROD_ENV, IS_DEV_ENV } from "./env";

export const LOCAL_BASE_URL = "http://localhost:5000/api/";

export const BASE_URL =
  IS_PROD_ENV || (IS_DEV_ENV && !apiConfig.useLocalBaseUrlDuringDevelopment)
    ? (process.env.REACT_APP_API_BASE_URL as string)
    : LOCAL_BASE_URL;
